import { ChartType } from 'shared/types/analytics';
import type { ChartData } from '../catalog/types';

export type ChartTableCell = string | number | null;

export type ChartTable = Readonly<{
  headers: readonly string[];
  rows: readonly (readonly ChartTableCell[])[];
}>;

export type ChartTableLabels = Readonly<{
  category: string;
  value: string;
  /** Row labels for triplet charts, in `tripletValues` order. */
  triplet: readonly string[];
}>;

/** Flattens chart data into a table used by CSV/XLSX exports. */
export function buildChartTable(
  type: ChartType,
  data: ChartData,
  labels: ChartTableLabels
): ChartTable {
  if (type === ChartType.triplet) {
    const values = data.tripletValues ?? [];
    return {
      headers: [labels.category, labels.value],
      rows: labels.triplet.map((label, index) => [
        label,
        values[index] ?? null,
      ]),
    };
  }

  if (type === ChartType.line || type === ChartType.area) {
    const series = data.lineSeries ?? [];
    const categories = data.categories ?? data.labels;
    return {
      headers: [labels.category, ...series.map((entry) => entry.label)],
      rows: categories.map((category, index) => [
        category,
        ...series.map((entry) => entry.values[index] ?? null),
      ]),
    };
  }

  return {
    headers: [labels.category, labels.value],
    rows: data.labels.map((label, index) => [label, data.values[index] ?? null]),
  };
}
